export function numberWithSpaces(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, "$1 $2");

  return x;
}

export function formatValue(value) {
  // console.log(value, numberWithSpaces(value));
  if (!Number.isNaN(Number(value))) {
    return numberWithSpaces(value);
  } else return value;
}
export function formatCost(value) {

 return ` ${Number(value).toLocaleString('ru-RU', { useGrouping: true, minimumFractionDigits: 0 })} ₽`;
}

